import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import printJS from 'print-js';
import API from 'apiService';

const FormSuccess = ({
  formIRT = {},
  isShow,
  PIRTTrans = {},
  formData = {},
}) => {
  const { name, last_name, nik, dep_name, dep_address } = formData;
  const contentRef = useRef();

  const requestCertificate = async () => {
    const res = await API.getblob("/pirt/pirt_trans/print/success/" + PIRTTrans.id);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  return (
    isShow && (
      <>
        <div className="row">
          <div className="col-lg-6">
            <h1 className="mr-2 d-inline">Pendaftaran Penyuluhan Berhasil</h1>
            <span className="text-success">
              <i className="fas fa-check-circle fa-lg" />
            </span>
            <table className="table table-flush mt-2" ref={ contentRef }>
              <tr>
                <td>
                  <b>ID Pendaftaran Penyuluhan</b>
                </td>
                <td>{PIRTTrans.id}</td>
              </tr>
              <tr>
                <td>
                  <b>Nama Penanggung Jawab</b>
                </td>
                <td>{formIRT.pic_production_name}</td>
              </tr>
              <tr>
                <td>
                  <b>NIB</b>
                </td>
                <td>{formIRT.irt_name}</td>
              </tr>
              <tr>
                <td>
                  <b>Alamat IRT</b>
                </td>
                <td>{formIRT.irt_address}</td>
              </tr>
              <tr>
                <td>
                  <b>Waktu Penyuluhan</b>
                </td>
                <td>
                    Info akan dikirimkan lewat wa / email
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            {/* <ReactToPrint
              trigger={ () => (
                <button
                  className="btn btn-icon btn-primary float-right"
                  type="button"
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-print" />
                  </span>
                  <span className="btn-inner--text">Cetak</span>
                </button>
              ) }
              content={ () => contentRef.current }
            /> */}
            <button
                  className="btn btn-icon btn-primary float-right"
                  type="button"
                  onClick = {()=> requestCertificate()}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-print" />
                  </span>
                  <span className="btn-inner--text">Cetak</span>
                </button>
          </div>
        </div>
      </>
    )
  );
};

export default FormSuccess;
